export default "__VITE_ASSET__57355ba3__"